export class Question {
  protected _type: string = '';
  protected _answers: string[] = [];
  
  prompt: string = '';
  correctAnswer: number;
  correctFeedback: string = '';
  incorrectFeedback: string = '';

  get typeString() { return this._type === 'multiple-choice' ? 'Multiple Choice' : 'True/False'; }
  get type() { return this._type; }
  get answers() { return this._answers; }

  constructor(json?: any) {
    if (json) this.updateWithJson(json);
  }

  updateWithJson(json: any) {
    if (json.question_type) this.type = json.question_type;
    if (json.correct_answer != undefined) this.correctAnswer = json.correct_answer;
    if (json.answers) this.answers = json.answers;
    if (json.prompt) this.prompt = json.prompt;
    if (json.feedback) {
      if (json.feedback.correct) this.correctFeedback = json.feedback.correct;
      if (json.feedback.incorrect) this.incorrectFeedback = json.feedback.incorrect;
    }
  }

  get alwaysFeedback() {
    if (this.correctFeedback === this.incorrectFeedback) return this.correctFeedback;
    return '';
  }

  set alwaysFeedback(feedback: string) {
    this.correctFeedback = feedback;
    this.incorrectFeedback = feedback;
  }

  set type(type: string) {
    if (type === 'true-false' || type === 'multiple-choice') {
      this._type = type;
    }
    if (type === 'true-false') {
      this.answers = ['True', 'False'];
    }
  }

  // Only allow answers to be set if type is true-false
  set answers(answers: any[]) {
    if (answers.length) {
      if (typeof answers[0] === 'string') {
        this._answers = answers;
      } else {
        this._answers = answers.map((answer, i) => {
        if (answer.is_correct) this.correctAnswer = i;
          return answer.text;
        });
      }
    }
  }

  toJson() {
    let json: any = {
      prompt: this.prompt,
      question_type: this.type,
      answers: this.answers,
      correct_answer: this.correctAnswer
    };
    if (this.correctFeedback || this.incorrectFeedback) {
      json.feedback = {
        correct: this.correctFeedback,
        incorrect: this.incorrectFeedback
      }
    }
    return json;
  }

  copy() {
    return new Question(this.toJson());
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/question.model.ts